import comp from "./QuestionCardTag";
export default comp;
